export const INITAL_CLUBBED_AUTH_MODAL_BASIC_DETAILS_STATE = {
  name: '',
  age: '',
  gender: 'male',
  contentLanguages: [sessionStorage.getItem('languageCode')],
}
